export interface Example {
    marker: string;
    activationPhrase: string;
    request: string;
}

export const makeEmptyExample = (): Example => ({
    marker: '',
    activationPhrase: '',
    request: '',
});

export const isEmptyExample = (example: Example) => {
    return !example || (!example.marker && !example.activationPhrase && !example.request);
};

export const markers = [
    { text: 'запусти навык', hasRequest: false },
    { text: 'запусти чат с', hasRequest: false },
    { text: 'давай поиграем в', hasRequest: false },
    { text: 'сыграем в', hasRequest: false },
    { text: 'давай сыграем в', hasRequest: false },
    { text: 'поиграем в', hasRequest: false },
    { text: 'скажи', hasRequest: true },
    { text: 'попроси', hasRequest: true },
    { text: 'узнай у', hasRequest: true },
    { text: 'спроси у', hasRequest: true },
];

export interface SmartHomeDeepLinks {
    ios?: {
        url?: string | null;
        fallbackUrl?: string | null;
    };
    android?: {
        url?: string | null;
    };
}
